/** 
 * @props formTitle: [string] Form title whose fields needs to be mapped with external system
 * @props toBeMappedFormBoxes: [array of objects] list of form boxes that are need to be mapped
 * @props thirdPartyColumns: [array of objects] list of third party fields
*/

import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import DraggableItem from '../draganddrop/DraggableItem';
import DropTarget from '../draganddrop/DropTarget';
import { HEADING } from '../heading/constants/constants';
import Heading from '../heading/Heading';
import HoverContainer from '../hovercontainer/HoverContainer';
import { VEC_ICON_NAME } from '../icons/constants';
import Icons from '../icons/Icons';
import styles from './DraggableManualMatcher.styles';
export default function DraggableManualMatcher({formTitle, thirdPartyTitle, draggableFormBoxes, mappedFields, setDraggableFormBoxesCb, setMappedFieldsCb}){

    const handleDrop = (e, dropTargetIdentifier) => {
        const droppedBoxObj = JSON.parse(e.dataTransfer.getData('dataObj'));
        setDraggableFormBoxesCb(draggableFormBoxes.map((field, idx) => {
            if(field.label === droppedBoxObj.label){
                return {
                    ...field,
                    mapped: true,
                }
            }else{
                return {...field};
            }
        }));

        setMappedFieldsCb(mappedFields.map((field, idx) => {
            if(field.id === dropTargetIdentifier){
                return {
                    id: field.id,
                    label: field.label,
                    matchedFormField: droppedBoxObj,
                }
            }else{
                return {...field};
            }
        }));
    };
    const handleRemoveBox = (matchedField, idx) => {
        setDraggableFormBoxesCb(draggableFormBoxes.map((field, idx) => {
            if(field.id === matchedField.id){
                return {
                    ...field,
                    mapped: false,
                }
            }else{
                return {...field};
            }
        }));

        setMappedFieldsCb(mappedFields.map((field, idx) => {
            if(field.matchedFormField && field.matchedFormField.id === matchedField.id){
                return {
                    ...field,
                    matchedFormField: null,
                }
            }else{
                return {...field};
            }
        }));
    }

    return (
        <>
            <div style={styles.fieldMappingContainer}>
                <div style={styles.formFieldsContainer}>
                    <Heading type={HEADING.H3}>{formTitle} Boxes</Heading>
                    {
                        draggableFormBoxes.map((item, idx) => {
                            return <div style={styles.mappedCardDiv}>
                                {
                                    (item?.mapped) ? 
                                        <Card style={{...styles.draggableCardStyle, ...styles.mappedBox}} >
                                            <div style={styles.cardContainer}>
                                                <h6>{item.label}</h6>
                                            </div>
                                        </Card>
                                    :
                                        <DraggableItem dataObj={{...item, key: idx}}>
                                            <Card style={styles.draggableCardStyle} >
                                                <div style={styles.cardContainer}>
                                                    <h6>{item.label}</h6>
                                                </div>  
                                            </Card> 
                                        </DraggableItem>
                                }
                            </div>
                        })
                    }
                </div>
                <div style={styles.thirdPartyFieldsSection}>
                    <div style={styles.columnHeadingsRow}>
                        <div style={styles.excelColumnHeading}><Heading type={HEADING.H3}>Column in {thirdPartyTitle}</Heading></div>
                        <div><Heading type={HEADING.H3}>Map {thirdPartyTitle} columns to {formTitle} form</Heading></div>
                    </div>
                    <div style={styles.thirdPartyWhiteContainer}>
                    {
                        mappedFields.map((column, idx) => {
                            return <div style={styles.thirdPartyFieldGroup}>
                                <div style={styles.thirdPartyFieldCardContainer}>
                                    <span>{column.label}</span>
                                </div>
                                
                                <div style={styles.thirdPartyFieldDropCardContainer}>
                                    {
                                        (column.matchedFormField) ?
                                            <div style={{...styles.mappedCardDiv, ...styles.droppedCardDiv}}>
                                                <Card style={styles.draggableCardStyle} >
                                                    <div style={styles.cardContainer}>
                                                        <h6>{column.matchedFormField.label}</h6>
                                                    </div>   
                                                </Card>
                                                <span style={styles.removeBox}>
                                                    <HoverContainer onClick={() => handleRemoveBox(column.matchedFormField, idx)}>
                                                        <Icons familyName='vec' iconName={VEC_ICON_NAME.CLOSE} transformScale={0.5} />
                                                    </HoverContainer>
                                                </span>
                                            </div>
                                        :
                                            <div><DropTarget handleDropCb={handleDrop} dropTargetIdentifier={column.id} customStyles={styles.dropableAreaCard} hoverColor={"#83CFA4"}/></div>     
                                    }
                                </div>
                            </div>
                        })
                    }
                    </div>
                </div>
            </div>
        </>
    )
}